import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('loanProductsCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/loans/types?variation=REGULAR'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.loanProducts,
    cacheName: 'loanTypes'
  }));